import axios from 'axios';
import { useState, useEffect, useRef } from 'react';

export default function VlessMigration() {

	const [limit, setLimit] = useState(0);

	const [queryFrom, setQueryFrom] = useState('');
	const [queryTo, setQueryTo] = useState('');

	const [isLoading, setLoading] = useState(false);
	const [allServers, setAllServers] = useState([]);

	const [selectedServerFrom, setSelectedServerFrom] = useState('');
	const [selectedServerTo, setSelectedServerTo] = useState('');

	const [availableFrom, setAvailableFrom] = useState([]);
	const [availableTo, setAvailableTo] = useState([]);

	const [isOfflineV2OnlyMigration, setOfflineOnlyV2Migration] = useState(false);

	const [minutesLimit, setMinutesLimit] = useState(0);
	const [isNotifyingUser, setNotifyingUser] = useState(false);

	const processingRequest = useRef(false);

	const getServers = async () => {
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		const request = await axios.post('https://sasovo.cdn-yandex.net/v4/vless/getList', {}, { headers: { Authorization: `Bearer ${token}` } });
		const servers = request.data.keys;
		setAllServers(servers);
	};

	useEffect(() => {
		getServers();
	}, []);

	const migrateUsers = async (event) => {
		event.preventDefault();

		if (processingRequest.current === true) {
			return;
		}

		if (isOfflineV2OnlyMigration && minutesLimit === 0) {
			alert("Minutes can't be 0")
			return
		}

		processingRequest.current = true
		const data = {
			server_api_from: selectedServerFrom,
			server_api_to: selectedServerTo,
			limit: limit,
			is_offline_migration: isOfflineV2OnlyMigration,
			offline_migration_minutes_limit: minutesLimit,
			is_notifying_user: isNotifyingUser
		};

		console.log({ data });

		if (selectedServerFrom === '' || selectedServerTo === '') {
			return;
		}

		console.log({ data });

		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		setLoading(true);

		const request = await axios.post('https://sasovo.cdn-yandex.net/v4/migrateGroup/vless', data, { headers: { Authorization: `Bearer ${token}` } });
		console.log({ request: request.data });
		setLoading(false);

		processingRequest.current = false;

		if (request.data.ok) {
			alert(`Migration successful, ${request.data.count} keys migrated`);
		} else {
			alert("Migration failed, call Sereja")
		}
	};

	useEffect(() => {
		if (allServers.length === 0) {
			return;
		}
		console.log('UPDATE');
		const filters = allServers.filter((server) => server.url.includes(queryTo));
		setAvailableTo(filters);
		if (filters[0]) {
			setSelectedServerTo(filters[0].id);
		}
	}, [queryTo]);

	useEffect(() => {
		if (allServers.length === 0) {
			return;
		}
		console.log('UPDATE');
		const filters = allServers.filter((server) => server.url.includes(queryFrom));
		setAvailableFrom(filters);
		if (filters[0]) {
			setSelectedServerFrom(filters[0].id);
		}
	}, [queryFrom]);

	return (
		<div className='content-block t-container'>
			<div className='t-content'>
				<div className='page-header'>
					<h1>Migration [ Vless ]</h1>
				</div>
			</div>
			<form onSubmit={migrateUsers} className='t-content'>
				<div className='migration-c'>
					<div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
						Current Server
						<input
							type='text'
							className='t-input'
							placeholder='Filter IP Address (OLD)'
							value={queryFrom}
							onChange={(e) => setQueryFrom(e.target.value)}
						></input>
						<select
							value={selectedServerFrom}
							onChange={(e) => {
								console.log({ e: e.target.value });
								setSelectedServerFrom(e.target.value);
							}}
							className='t-input'
						>
							{availableFrom.map((server) => {
								return (
									<option value={server.id}>
										<b>{server.comment}</b> {' | ' + server.url}
									</option>
								);
							})}
						</select>
					</div>
					<div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
						New Server
						<input
							type='text'
							className='t-input'
							placeholder='Filter IP Address (NEW)'
							value={queryTo}
							onChange={(e) => setQueryTo(e.target.value)}
						></input>
						<select
							value={selectedServerTo}
							onChange={(e) => {
								console.log({ e: e.target.value });
								setSelectedServerTo(e.target.value);
							}}
							className='t-input'
						>
							{availableTo.map((server) => {
								return (
									<option value={server.id}>
										<b>{server.comment}</b> {' | ' + server.url}
									</option>
								);
							})}
						</select>
					</div>
					<div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
						Migration User Limit
						<input
							type='number'
							className='t-input'
							value={limit}
							onChange={(e) => setLimit(e.target.value)}
							placeholder='Migration User Limit'
						/>
					</div>
				</div>

				<button type='submit' disabled={isLoading} className='t-button'>
					{isLoading ? <>Migrating...</> : <>Start Migration</>}
				</button>
				<div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
					<input type='checkbox' checked={isOfflineV2OnlyMigration} onChange={e => setOfflineOnlyV2Migration(e.target.checked)} />
					<label>Migrate only offline users (V2)</label>
				</div>
				{isOfflineV2OnlyMigration && <div>
					<label>Do not migrate if user was online in X minutes</label>
					<input className='t-input' value={minutesLimit} onChange={e => setMinutesLimit(e.target.value)} defaultValue={0} />
				</div>}
				<div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
					<input type='checkbox' checked={isNotifyingUser} onChange={e => setNotifyingUser(e.target.checked)} />
					<label>Notify users about migration</label>
				</div>
			</form>
		</div>
	);
}
